export default __webpack_public_path__ + "assets/static/data/spyne-docs-data.4f8a7656ec6ae68669981cd78e0feff6.json";